enum NotificationDocumentTypeId {
	Pdf = 1,
	Png = 2,
	Html = 3
}

export default NotificationDocumentTypeId;
